module.exports = __webpack_public_path__ + "img/generic-module.3f9d86ea.svg";